/**
 * Created by Administrator on 2018/6/19.
 */
export default {
    state:{
        isShowHeader:true,
        isShowFooter:true
    },
    getters:{
        getShowHeader(state){
            return state.isShowHeader;
        },
        getShowFooter(state){
            return state.isShowFooter;
        },
    },
    mutations:{
        showHF(state){
            state.isShowHeader = true;
            state.isShowFooter = true;
        },
        hideHF(state){
            state.isShowHeader = false;
            state.isShowFooter = false;
        },
    },
    actions:{
        showHF(context){
            context.commit('showHF');
        },
        hideHF(context){
            context.commit('hideHF');
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/hf1.js